<h2>Общая стастистика</h2>

<div class="container common-stats-content">
  <app-date-filter (dateFilter)="changeDateFilter($event)"></app-date-filter>

  <div class="probable-income-container">
    <h3 class="table-name">Вероятный доход по играм: </h3>
    <div>
      <mat-table [dataSource]="probableIncomeDataSource" class="table probable-income-table"
                 matSortActive='income'
                 matSortDirection='desc'
                 matSort #matSortProbableGamingIncome>

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
        </ng-container>

        <!-- game Column -->
        <ng-container matColumnDef="game">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Игра</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.game}}</mat-cell>
        </ng-container>

        <!-- income Column -->
        <ng-container matColumnDef="income">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Доход</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                [ngClass]="element.income>0?'green':'red'"
                matTooltip="{{element.income | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast">
                {{element.income / 100 | number}}
              </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="probableIncomeColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: probableIncomeColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
  </div>
  <mat-divider class="divider"></mat-divider>
  <div class="profit-by-game-container">
    <h3 class="table-name">По играм: </h3>
      <mat-table [dataSource]="statByGameDataSource" class="table profit-by-game-table"
                 matSortActive='total'
                 matSortDirection='desc'
                 matSort #matSortGames>

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
        </ng-container>

        <!-- type Column -->
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Тип</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.type}} {{logType[element.type]}}
          </mat-cell>
        </ng-container>

        <!-- agentKey Column -->
        <ng-container matColumnDef="agentKey">
          <mat-header-cell *matHeaderCellDef>agentKey</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.agentKey }} </mat-cell>
        </ng-container>

        <!-- total Column -->
        <ng-container matColumnDef="total">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Выиграно</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                [ngClass]="element.total>0?'green':'red'"
                matTooltip="{{element.total | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.total / 100 | number}}
              </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="statByGameColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: statByGameColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  </div>
  <mat-divider class="divider"></mat-divider>
  <div class="profit-by-case-container">
    <h3 class="table-name">По кейсам</h3>
    <div>
      <mat-table [dataSource]="statByCaseDataSource" class="table profit-by-case-table"
                 matSortActive='profit'
                 matSortDirection='desc'
                 matSort #matSortCase>

        <!-- count Column -->
        <ng-container matColumnDef="row">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Название</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.name}} </mat-cell>
        </ng-container>

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Открыто</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span>
                {{element.count}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- bet Column -->
        <ng-container matColumnDef="bets">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Поставлено</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.bets | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.bets / 100| number}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- wons Column -->
        <ng-container matColumnDef="wons">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Выиграно</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.wons  | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.wons / 100 | number}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- profit Column -->
        <ng-container matColumnDef="profit">
          <mat-header-cell *matHeaderCellDef  mat-sort-header>Профит</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                [ngClass]="element.profit>0?'green':'red'"
                matTooltip="{{element.profit  | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.profit / 100 | number}}
              </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="statByCaseColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: statByCaseColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуютт</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
  </div>
  <mat-divider class="divider"></mat-divider>
  <div class="profit-by-case-container">
    <h3 class="table-name">По кейсам в батлах</h3>
    <div>
      <mat-table [dataSource]="statByCaseBattlesDataSource" class="table profit-by-case-table"
                 matSortActive='profit'
                 matSortDirection='desc'
                 matSort #matSortCaseBattles>

        <!-- count Column -->
        <ng-container matColumnDef="row">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Название</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.name}} [{{element.case_id}}] </mat-cell>
        </ng-container>

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Открыто</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span>
                {{element.opens}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- bet Column -->
        <ng-container matColumnDef="bets">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Поставлено</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.bets | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.bets / 100| number}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- wons Column -->
        <ng-container matColumnDef="wons">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Выиграно</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.wons  | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.wons / 100 | number}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- profit Column -->
        <ng-container matColumnDef="profit">
          <mat-header-cell *matHeaderCellDef  mat-sort-header>Профит</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                [ngClass]="element.profit>0?'green':'red'"
                matTooltip="{{element.profit  | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >
                {{element.profit / 100 | number}}
              </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="statByCaseBattlesColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: statByCaseBattlesColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуютт</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>
  </div>
</div>



